import FormElementSwitch from '@/components/FormElementSwitch/FormElementSwitch';

export default FormElementSwitch;
